export default __webpack_public_path__ + "static/media/81.e37272a3.jpg";